export const executionListColumnheader = [
    {
        name: 'Name',
        key: 'benf_name',
        sortable: true,
        filterRequired: true,
        filterDefault: true,
        width: 180,
    },
    {
        name: 'ABHA ID',
        key: 'abha_id',
        sortable: true,
        filterRequired: true,
        filterDefault: true,
        width: 180,
    },
    {
        name: 'Mobile Number',
        key: 'mob',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Spouse/Guardian Name',
        key: 'spouse_name',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Service Due',
        key: 'service_period_full_name',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Service Status',
        key: 'service_period_status_name',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Service Due Date',
        key: 'service_due_date',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Beneficiary Arrived',
        key: 'benificiary_arrival_status',
        sortable: true,
        filterRequired: true,
        filterDefault: false,
        width: 180,
    },
    {
        name: 'Action',
        key: 'Action',
        sortable: false,
        filterRequired: false,
        filterDefault: false,
        width: 180,
    }
];

export const list_filter_details = {
    name: {
        'type': 'textfield',
        'title': 'Name',
        'filter_key': 'name',
        'value': '',
        'isFilterDisable': true,
        'isfilterShow': true,
    },
    abhaId: {
        'type': 'textfield',
        'title': 'Abha Id',
        'filter_key': 'abhaId',
        'value': '',
        'isFilterDisable': true,
        'isfilterShow': true,
    },
    mobileNumber: {
        'type': 'textfield',
        'title': 'Mobile Number',
        'filter_key': 'mobileNumber',
        'value': '',
        'isFilterDisable': true,
        'isfilterShow': true,
    },
    serviceStatus: {
        'type': 'radioButton',
        'title': 'Service Due',
        'filter_key': 'serviceStatus',
        'required': true,
        'group': 'serviceStatus',
        'options': ["Due", "Overdue"],
        'value': '',
        'isFilterDisable': true,
        'isfilterShow': true,
    },
    serviceCategory: {
        'type': 'select',
        'title': 'Service Category',
        'filter_key': 'serviceCategory',
        'multiDropdown': true,
        'options': [],
        'value': '',
        'isFilterDisable': false,
        'isfilterShow': false,
    }
};

export const list_filter_details_add_benef = {
    name: {
        'type': 'textfield',
        'title': 'Name',
        'filter_key': 'name',
        'value': '',
        'isFilterDisable': true,
        'isfilterShow': true,
    },
    abhaId: {
        'type': 'textfield',
        'title': 'Abha Id',
        'filter_key': 'abhaId',
        'value': '',
        'isFilterDisable': true,
        'isfilterShow': true,
    },
    mobileNumber: {
        'type': 'textfield',
        'title': 'Mobile Number',
        'filter_key': 'mobileNumber',
        'value': '',
        'isFilterDisable': true,
        'isfilterShow': true,
    }
};

export const actionData = {
    deleteBenfList: {
        'type': 'radioButton',
        'title': 'Remove beneficiary from event',
        'filter_key': 'deleteBenfList',
        'required': true,
        'group': 'deleteBenfList',
        'options': ['Availed Service outside of RCH', 'Migrated Out', 'Others'],
        'value': '',
    },
    arrivalBenfList: {
        'type': 'radioButton',
        'title': 'Beneficiary Arrived',
        'filter_key': 'arrivalBenfList',
        'required': true,
        'group': 'arrivalBenfList',
        'options': ['Yes arrived', 'No, not arrived'],
        'value': '',
    },
};

export const session_type = {
    today: 'today',
    upcoming: 'upcoming',
    completed: 'completed'
}

export const colors: any = {
    vhnd: '#af2d94',
    uhnd: '#a8c4d4',
    outreach: '#b49cc4',
};

export const execution_message = {
    errorMessageVhndExecutionStatus: 'Error in get vhnd execution status.',
    errorMessageArivalStatus: 'Error in get arrival status.',
    errorMessageRemovalReasonData: 'Error in get removal reason data.',
    errorMessageServiceCategoryDetails: 'Error in get service category data.',
    errorMessageSessionDetails: 'Error in get session details.',
    errorMessageUpcomingSessionDetails: 'Error in get upcoming session details.',
    errorMessageCompletedSessionDetails: 'Error in get completed session details.',
    errorMessageUpcomingSessionAnmDetails: 'Error in get upcoming session health provider details.',
    errorMessageCompletedSessionAnmDetails: 'Error in get completed session health provider details.',
    errorMessageBenfListDetails: 'Error in get beneficiary list.',
    errorMessageStartOrEndSessionDetails: 'Error in Event status change.',
    errorMessageBeneficiaryRemove: 'Error in removing beneficiary.',
    errorMessageBeneficiaryArrival: 'Error in beneficiary arrival status update.',
    errorMessageDownloadBenfDetails: 'Error in download session beneficiary details.',
    errorMessageInitiateSessionDetails: 'Error in initiate session.',
    successMessageInitiateSessionDetails: 'Session initiated successfully.',
    successMessageBeneficiaryRemoval: 'Beneficiary removed successfully.',
    successMessageBeneficiaryArrival: 'Beneficiary arrival status updated successfully.',
    successMessageEventStatus: 'Event status updated successfully.',
    errorMessageAddBenf: 'Error in add beneficiary to due list'
};

export const status_type: any = {
    confirm: {
        status_name: 'confirm',
        status_code: 'confirmed'
    },
    initiate: {
        status_name: 'initiate',
        status_code: 'initiated'
    },
    start: {
        status_name: 'start',
        status_code: 'started'
    },
    end: {
        status_name: 'end',
        status_code: 'completed'
    },
    yes: {
        status_name: 'Yes',
        status_code: 'yes' 
    },
    no: {
        status_name: 'No',
        status_code: 'no' 
    },
    added: {
        status_name: 'Added',
        status_code: 'added' 
    }
};

export const actioModalFlow = {
    deleteBenfDueList: 'deleteBenfDueList',
    arrivalBenfDueList: 'arrivalBenfDueList'
};

export const executionRoleCode = {
    module_code: "VHNDUHND_Execution",
    pageCode: {
        VHNDUHND_Execution_LstPg: 'VHNDUHND_Execution_LstPg',
        VHNDUHND_Execution_start: 'VHNDUHND_Execution_start',
        VHNDUHND_Execution_end: 'VHNDUHND_Execution_end',
        VHNDUHND_Execution_confirm: 'VHNDUHND_Execution_confirm',
        VHNDUHND_Execution_initiate: 'VHNDUHND_Execution_initiate',
        VHNDUHND_Execution_add_benef: 'VHNDUHND_Execution_add_benef',
        VHNDUHND_Execution_delete_benef: 'VHNDUHND_Execution_delete_benef'
    }
};

